import _implicitStylesheets from "./footer.css";
import _implicitScopedStylesheets from "./footer.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import _axImage from "ax/image";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="page-link${0}"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<p class="legal${0}"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "footer": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "footer-content": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "footer-links-wrapper": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "footer-links": true
  },
  key: 3
};
const stc4 = {
  classMap: {
    "link-wrapper": true
  },
  key: 9
};
const stc5 = {
  "privacy-choices-icon": true
};
const stc6 = {
  classMap: {
    "sub-footer-links": true
  },
  key: 12
};
const stc7 = {
  "language": true
};
const stc8 = {
  classMap: {
    "http-symbol": true
  },
  props: {
    "icon": "http",
    "iconDescription": "Language selector",
    "spriteUrl": "/images/symbols.svg"
  },
  key: 14
};
const stc9 = {
  classMap: {
    "social-media": true
  },
  key: 19
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, b: api_bind, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("footer", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_element("nav", stc3, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.offerYourSolution,
      "target": "_blank"
    },
    key: 4
  }), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.privacyStatement,
      "target": "_blank"
    },
    key: 5
  }), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.securityStatement,
      "target": "_blank"
    },
    key: 6
  }), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.termsOfUse,
      "target": "_blank"
    },
    key: 7
  }), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.cookiePreferences,
      "target": "_blank"
    },
    key: 8,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClickOnCookiePreferences))
    }
  }), api_element("div", stc4, [api_custom_element("ax-image", _axImage, {
    classMap: stc5,
    props: {
      "width": "100%",
      "variant": "rounded",
      "height": "100%",
      "imgSrc": $cmp.imageUrl
    },
    key: 10,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClickPrivacyChoices))
    }
  }), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.footerLinks.yourPrivacyChoices,
      "target": "_blank"
    },
    key: 11
  })])]), api_element("div", stc6, [api_element("a", {
    classMap: stc7,
    attrs: {
      "href": $cmp.appxSiteUrl
    },
    key: 13
  }, [api_custom_element("ax-icon", _axIcon, stc8), api_static_fragment($fragment1, 16, [api_static_part(1, null, api_dynamic_text($cmp.appxSiteUrlLabel))])]), api_static_fragment($fragment2, 18, [api_static_part(1, null, api_dynamic_text($cmp.legalText))])])]), api_element("div", stc9, [api_element("a", {
    attrs: {
      "href": "https://x.com/appexchange",
      "target": "_blank",
      "aria-label": $cmp.twitterLabel
    },
    key: 20
  }, [api_custom_element("ax-icon", _axIcon, {
    props: {
      "size": "large",
      "icon": "x-twitter",
      "iconSetType": "brands",
      "iconDescription": $cmp.twitterLabel
    },
    key: 21
  })]), api_element("a", {
    attrs: {
      "href": "https://www.linkedin.com/company/appexchange",
      "target": "_blank",
      "aria-label": $cmp.linkedInLabel
    },
    key: 22
  }, [api_custom_element("ax-icon", _axIcon, {
    props: {
      "size": "large",
      "icon": "linkedin-in",
      "iconSetType": "brands",
      "iconDescription": $cmp.linkedInLabel
    },
    key: 23
  })])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3s7e3h3rcev";
tmpl.legacyStylesheetToken = "undefined-_footer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
